/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2021 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: file-select-modal-component.ts
 *
 * Created by kyang on 2021-03-25.
 */

function FileSelectModalController(
    this: JS5Object,
    _: JS5Object,
) {


    //===================//
    // Template Response //
    //===================//

    this.isValidating = () => {
        return (
            _.get(this, 'buttonFile.type') === 'LOCAL'
            && _.get(this, 'buttonFile.status') === 'RUNNING'
        );
    };

    this.okButtonEnabled = () => {
        return _.get(this, 'buttonFile.status') === 'PASSED';
    };

    this.onOkClicked = () => {
        this.onSelectClicked({fileValue: this.buttonFile});
    };


    //=================//
    // Lifecycle Hooks //
    //=================//

    this.$onInit = () => {
        this.filePath = null;
    };

    this.onFileChanged = (newFile: JS5Object) => {
        this.buttonFile = newFile;
        this.dropFile = newFile;
        this.validationError = _.chain(newFile)
            .get('results.0.errors')
            .map((error: JS5Object) => {
                return error.description;
            })
            .join('; ')
            .value();

        switch (_.get(newFile, 'type')) {
            case 'LOCAL':
                this.filePath = newFile.files[0].file.name;
                break;
            case 'REMOTE':
                this.filePath = newFile.files[0].virtualPath;
                break;
            default:
                this.filePath = null;
        }
    };
}

angular
    .module('prism-ui.components')
    .component('fileSelectModal', {
        templateUrl: 'components/modal/fileSelectModal/file-select-modal-template.html',
        controller: FileSelectModalController,
        transclude: {
            // preview: This section is shown when file value is valid
            preview: '?fileSelectModalPreview'
        },
        bindings: {
            modalTitle: '<',
            dropZoneLabel: '<',

            getFileExtensions: '&',
            initializeUploaderConfig: '&',
            getLocalFilePreValidationErrors: '&',
            validateRemoteFile: '&',
            validateLocalFile: '&',
            validateProgress: '<?',
            buttonSources: '<?',
            buttonTooltips: '<?',

            onCancelClicked: '&',
            onSelectClicked: '&',
        }
    });
